import { useState } from 'react';
import { Dropdown } from 'framework/dropdown';

const options = [
  { value: 'option1', label: 'Option 1' },
  { value: 'option2', label: 'Option 2' },
  { value: 'option3', label: 'Option 3' },
  { value: 'option4', label: 'Option 4' },
  { value: 'AAAAA3AAAAA3AAAAA3AAAAA3AAAAA3AAAAA3', label: 'AAAAA 3' },
  { value: 'BBBBB3', label: 'BBBBB 3' },
  { value: 'BBBBB4', label: 'BBBBB 4' },
  { value: 'BBBBB5', label: 'BBBBB 5' },
  { value: 'BBBBB6', label: 'BBBBB 6' },
  { value: 'BBBBB7', label: 'BBBBB 7' },
  { value: 'BBBBB8', label: 'BBBBB 8' },
  { value: 'BBBBB9', label: 'BBBBB 9' },
  { value: 'BBBBB10', label: 'BBBBB 10' },
  { value: 'BBBBB11', label: 'BBBBB 11' },
  { value: 'BBBBB12', label: 'BBBBB 12' },
  { value: 'BBBBB13', label: 'BBBBB 13' },
];

export default () => {
  const [value, setSelect] = useState({ value: 'BBBBB11', label: 'BBBBB 11' });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
        gap: '20px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: 10 }}>
        <Dropdown
          label="Label"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          autosize
          padding="10px"
          value={value.value}
          onSelect={(o) => setSelect(o)}
          option_key="value"
          onKeyDown={() => console.log('keydown')}
          onClick={() => console.log('click')}
          onFocus={() => console.log('focus')}
          onBlur={() => console.log('blur')}
          onChange={() => console.log('change')}
          onRemove={() => setSelect({ value: '', label: '' })}
          options={options}
          extend
          filterable
        />
        <Dropdown
          label="Label"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          padding="10px"
          value={value.value}
          onSelect={(o) => setSelect(o)}
          option_key="value"
          onKeyDown={() => console.log('keydown')}
          onClick={() => console.log('click')}
          onFocus={() => console.log('focus')}
          onBlur={() => console.log('blur')}
          onChange={() => console.log('change')}
          onRemove={() => setSelect({ value: '', label: '' })}
          options={options}
          filterable
          clear
        />
      </div>
      <div style={{ flexGrow: 1 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: 10 }}>
        <Dropdown
          label="Label"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          padding="10px"
          value={value.value}
          onSelect={(o) => setSelect(o)}
          option_key="value"
          onKeyDown={() => console.log('keydown')}
          onClick={() => console.log('click')}
          onFocus={() => console.log('focus')}
          onBlur={() => console.log('blur')}
          onChange={() => console.log('change')}
          onRemove={() => setSelect({ value: '', label: '' })}
          options={options}
          extend
          filterable
          clear
        />
        <Dropdown
          label="Label"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          padding="10px"
          value={value.value}
          onSelect={(o) => setSelect(o)}
          option_key="value"
          onKeyDown={() => console.log('keydown')}
          onClick={() => console.log('click')}
          onFocus={() => console.log('focus')}
          onBlur={() => console.log('blur')}
          onChange={() => console.log('change')}
          onRemove={() => setSelect({ value: '', label: '' })}
          options={options}
          extend
          filterable
          clear
        />
      </div>
    </div>
  );
};
